module.exports = __webpack_public_path__ + "assets/Rampur-hound-baseWa.3576b608.svg";